import React from 'react';

const ELEMENT_CLASS = {
  ลม: 'tarot-card--air',
  น้ำ: 'tarot-card--water',
  ไฟ: 'tarot-card--fire',
  ดิน: 'tarot-card--earth',
};

export default function TarotCardFace({
  card,
  faceDown = false,
  selected = false,
  revealed = true,
  onClick,
  size = 'md',
  ariaLabel,
}) {
  if (faceDown || !card) {
    return (
      <button
        type="button"
        className={`tarot-card tarot-card--back tarot-card--${size}${selected ? ' tarot-card--selected' : ''}`}
        onClick={onClick}
        aria-label={ariaLabel || 'ไพ่คว่ำ — แตะเพื่อเปิด'}
        disabled={!onClick}
      >
        <div className="tarot-card__back-art">
          <span className="tarot-card__back-mandala" aria-hidden="true">✦</span>
          <span className="tarot-card__back-title">Hotto</span>
          <span className="tarot-card__back-sub">ไพ่ยิปซี</span>
        </div>
      </button>
    );
  }

  const elementClass = ELEMENT_CLASS[card.element] ?? 'tarot-card--air';

  return (
    <button
      type="button"
      className={`tarot-card tarot-card--face tarot-card--${size} ${elementClass}${selected ? ' tarot-card--selected' : ''}${revealed ? ' tarot-card--revealed' : ''}`}
      onClick={onClick}
      aria-label={ariaLabel || `ไพ่ ${card.nameTh}`}
      disabled={!onClick}
    >
      <div className="tarot-card__frame">
        <span className="tarot-card__number">{card.number}</span>
        <span className="tarot-card__symbol" aria-hidden="true">{card.symbol}</span>
        <h3 className="tarot-card__name-th">{card.nameTh}</h3>
        <p className="tarot-card__name-en">{card.nameEn}</p>
        <div className="tarot-card__meta">
          <span>{card.element}</span>
          <span>{card.planet}</span>
        </div>
        <ul className="tarot-card__keywords">
          {card.keywords.slice(0, 2).map((k) => (
            <li key={k}>{k}</li>
          ))}
        </ul>
      </div>
    </button>
  );
}
